import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-article-search',
    templateUrl: './article-search.component.html',
    styleUrls: ['./article-search.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, NgClass, FaIconComponent]
})
export class ArticleSearchComponent {
  faSearch = faSearch;
  searchForm:FormGroup;
  submitted = false;    
  @Output() search:EventEmitter<any> = new EventEmitter<any>();

  constructor( public fb: FormBuilder, private r: Router ){
    this.searchForm = this.fb.group
    ({
      searchInput: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]]
    });
  }

  onSubmit(): void {
    if (this.searchForm.invalid) {
      return;
    }
    this.submitted = true;     
    this.searchEvent(this.searchForm.get("searchInput")?.value);
  }
  searchEvent(val:any=null)
  {
    this.r.navigateByUrl('/articles?q='+val);
    this.search.emit(val);
  }

}
